module.exports = __webpack_public_path__ + "img/dbschenker.754fcbb0.png";